import * as React from "react";
import { TACTICS_TECHNIQUES_ATTRIBUTE_ID } from "components/event-definitions/constants";
import { ClickableTacticsTechniques } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const TacticsTechniquesColumnCell = ({ entity }) => /* @__PURE__ */ React.createElement(ClickableTacticsTechniques, { items: entity.tactics_techniques, filterKey: TACTICS_TECHNIQUES_ATTRIBUTE_ID });
export default TacticsTechniquesColumnCell;
